import { useState } from "react";
import Cookies from "js-cookie";

export const useTimezone = () => {
  const [timezone, setTimezoneState] = useState(
    Cookies.get("timezone") ?? "Asia/Kuala_Lumpur"
  );

  const setTimezone = (tz) => {
    Cookies.set("timezone", tz);
    setTimezoneState(tz);
  };

  return { timezone, setTimezone };
};
